export default "__VITE_ASSET__1bOt_6AU__"